import { theme } from "../../theme";
import { getDaysInMonth, isAfter, isBefore, isValid } from "date-fns";
/** Use this year as default, if year is not entered, when validating days. When user types in a day, with year empty, we don't want to invalidate it immediately since we don't know if he will enter a leap year.  */
const LEAP_YEAR = 2024;
export const getErrorMessage = (type, unit) => {
    const messages = {
        future: `${unit} is in the future`,
        past: `${unit} is in the past`,
        invalid: `Invalid ${unit}`,
    };
    return messages[type];
};
export const createDateString = (newMonth, newDay, newYear) => {
    if (newMonth && newDay && newYear) {
        return `${newYear.padStart(4, "0")}-${newMonth.padStart(2, "0")}-${newDay.padStart(2, "0")}`;
    }
    else
        return "";
};
export const removeNonNumericCharacters = (value) => value.replace(/\D/g, "");
/** Toggle color of border when separte field has/hasn't error */
export const toggleErrorColor = (fieldRef, color) => {
    const errorColors = {
        red: theme.color.errorRed,
        white: theme.color.white,
    };
    fieldRef.current.style.backgroundColor = `${errorColors[color]}50`; // add 50 opacity to color
};
export const clearError = (fieldRef, setError) => {
    toggleErrorColor(fieldRef, "white");
    setError("");
};
export const assignError = (fieldRef, setError, errorMessage) => {
    toggleErrorColor(fieldRef, "red");
    setError(errorMessage);
};
/**
 * Check if day enetered is valid number taking in consideration number of days entered month has.
 * */
export const isValidDay = (month, day, year) => {
    if (!month)
        return Boolean(Number(day) < 32);
    // Number entered is less than current month has days.
    return (Number(day) <=
        getDaysInMonth(new Date(`${Number(month)}/01/${year || LEAP_YEAR}`)));
};
/**  When date is pasted or has initial values we need to format them to fit into belonging box.*/
export const formatFieldsForPreFill = (value) => {
    const date = new Date(value);
    const fields = {
        formatedMonth: "",
        formatedDay: "",
        formatedYear: "",
    };
    if (isValid(date)) {
        const newMonth = date.getUTCMonth() + 1;
        fields.formatedMonth = newMonth.toString().padStart(2, "0").substring(0, 2);
        fields.formatedDay = date
            .getUTCDate()
            .toString()
            .padStart(2, "0")
            .substring(0, 2);
        fields.formatedYear = date
            .getUTCFullYear()
            .toString()
            .padStart(4, "0")
            .substring(0, 4);
        return fields;
    }
    return fields;
};
/** Check does entered date fall between provided range */
export const validateRange = (enteredDate, range) => {
    if (!range)
        return {
            isBefore: false,
            isAfter: false,
        };
    const currentDate = new Date();
    const currentYear = currentDate.getUTCFullYear();
    const oldestAllowedDate = new Date(currentDate.setFullYear(currentYear - range.before[0]));
    const allowedYearsInFuture = new Date(currentDate.setFullYear(currentYear + range.after[0]));
    return {
        isBefore: isBefore(enteredDate, oldestAllowedDate),
        isAfter: isAfter(enteredDate, allowedYearsInFuture),
    };
};
